<script>
  import { portal } from "svelte-portal";
  import { fade, scale } from "svelte/transition";
  import { replaceIframes } from "../../Helper";
  const HTML_CLASS_LIST = document.documentElement.classList;
  const OVERFLOW_CLASS = "overflow-hidden";
  const OVERLAY_CLASS = "has-overlay";

  export let visible = false;
  export let item;
  export let openKey = "+";

  $: if (visible) {
    HTML_CLASS_LIST.add(OVERFLOW_CLASS, OVERLAY_CLASS);
  } else {
    HTML_CLASS_LIST.remove(OVERFLOW_CLASS, OVERLAY_CLASS);
  }
</script>

<svelte:window
  on:keyup={(event) => {
    const key = event.key;
    if (key === "Escape" || key === "-") {
      visible = false;
    }
    if (key === openKey) {
      visible = true;
    }
  }}
/>

{#if visible && item}
  <div transition:fade={{ duration: 200 }} use:portal={"body"} aria-hidden="true" class="fixed inset-0 z-60 bg-black/80 backdrop-blur supports-[backdrop-filter]:bg-black/75" />
  <div
    transition:fade={{ duration: 200 }}
    use:portal={"body"}
    role="dialog"
    aria-modal="true"
    class="fixed inset-0 z-70 grid grid-rows-[minmax(0,1fr)_auto_minmax(0,1fr)] overflow-auto px-8 py-10 text-theme-minor-50"
  >
    <button
      title="Schließen"
      type="button"
      class="fixed right-2 top-0 text-5xl opacity-80 hocus:opacity-100"
      on:click={() => {
        visible = false;
      }}>&times;</button
    >
    <figure transition:scale={{ duration: 200 }} class="row-start-2 flex flex-col items-center justify-center">
      <img class="pointer-events-none" src={item?.imageSrc} alt="" />
      {#if item?.text}
        <figcaption class="lightbox mx-auto max-w-4xl p-6 pb-0">
          {@html replaceIframes(item.text)}
        </figcaption>
      {/if}
    </figure>
  </div>
{/if}

<style global>
  figcaption.lightbox * {
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
</style>
